import { render, staticRenderFns } from "./ads.vue?vue&type=template&id=3f558567&scoped=true"
import script from "./ads.vue?vue&type=script&lang=js"
export * from "./ads.vue?vue&type=script&lang=js"
import style0 from "./ads.vue?vue&type=style&index=0&id=3f558567&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f558567",
  null
  
)

export default component.exports